export const DMM_KEIRIN_YOUTUBE_CH_ID = 'UCmiXL_z9owqynl0pFQ8XjTA';
